import axios from "axios";
import { Form } from "devextreme-react";
import {
  EmptyItem,
  GroupItem,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import DataSource from "devextreme/data/data_source";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NY } from "../data";
import {
  updateCmt,
  updateEndDate,
  updateFuRpt,
  updateFuRptDate,
  updateIRBRpt,
  updateIRBRptCmt,
  updateIRBRptDate,
  updateOngoing,
  updateOnsetDate,
  updateRptTerm,
  updateSiteNo,
  updateSubjectNo,
} from "./Redux/sae";

export default function SAEForm(props) {
  const { contrNo, SAE, formSAERef } = props;

  const dispatch = useDispatch();

  const [siteDataSource, setSiteDataSource] = useState(null);
  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/siteInfo/${contrNo}`
    );

    setSiteDataSource(
      new DataSource({
        store: {
          data: result.data,
          type: "array",
          key: "siteNo",
        },
      })
    );
  }, [contrNo]);

  const itemRender = ({ siteNo, LAB_NAME, INSPCT_MANAGER_NAME }) => {
    return (
      <div>
        {siteNo}-{LAB_NAME}-{INSPCT_MANAGER_NAME}
      </div>
    );
  };

  const displayExpr = (item) => {
    if (item) {
      return `${item.siteNo}-${item.LAB_NAME}-${item.INSPCT_MANAGER_NAME}`;
    } else {
      return null;
    }
  };

  const onSiteNoValueChanged = (e) => {
    dispatch(
      updateSiteNo({
        siteNo: e.value,
      })
    );
  };

  const onSubjectNoValueChanged = (e) => {
    dispatch(
      updateSubjectNo({
        subjectNo: e.value,
      })
    );
  };

  const onRptTermValueChanged = (e) => {
    dispatch(
      updateRptTerm({
        rptTerm: e.value,
      })
    );
  };

  const onOnsetDateValueChanged = (e) => {
    dispatch(
      updateOnsetDate({
        onsetDate: e.value,
      })
    );
  };

  const onOngoingValueChanged = (e) => {
    dispatch(
      updateOngoing({
        ongoing: e.value,
      })
    );
  };

  const onEndDateValueChanged = (e) => {
    dispatch(
      updateEndDate({
        endDate: e.value ? e.value : null,
      })
    );
  };

  const onInitialValueChanged = (e) => {
    dispatch(
      updateFuRptDate({
        initial: e.value ? e.value : null,
      })
    );
  };

  const on1stValueChanged = (e) => {
    dispatch(
      updateFuRptDate({
        "1st": e.value ? e.value : null,
      })
    );
  };

  const on2ndValueChanged = (e) => {
    dispatch(
      updateFuRptDate({
        "2nd": e.value ? e.value : null,
      })
    );
  };

  const on3rdValueChanged = (e) => {
    dispatch(
      updateFuRptDate({
        "3rd": e.value ? e.value : null,
      })
    );
  };

  const on4thValueChanged = (e) => {
    dispatch(
      updateFuRptDate({
        "4th": e.value ? e.value : null,
      })
    );
  };

  const on5thValueChanged = (e) => {
    dispatch(
      updateFuRptDate({
        "5th": e.value ? e.value : null,
      })
    );
  };

  const on6thValueChanged = (e) => {
    dispatch(
      updateFuRptDate({
        "6th": e.value ? e.value : null,
      })
    );
  };

  const on7thValueChanged = (e) => {
    dispatch(
      updateFuRptDate({
        "7th": e.value ? e.value : null,
      })
    );
  };

  const on8thValueChanged = (e) => {
    dispatch(
      updateFuRptDate({
        "8th": e.value ? e.value : null,
      })
    );
  };

  const on9thValueChanged = (e) => {
    dispatch(
      updateFuRptDate({
        "9th": e.value ? e.value : null,
      })
    );
  };

  const on10thValueChanged = (e) => {
    dispatch(
      updateFuRptDate({
        "10th": e.value ? e.value : null,
      })
    );
  };

  const onCmtValueChanged = (e) => {
    dispatch(
      updateCmt({
        cmt: e.value ? e.value : null,
      })
    );
  };

  const onIRBRptValueChanged = (e) => {
    dispatch(
      updateIRBRpt({
        IRBRpt: e.value ? e.value : null,
      })
    );
  };

  const on1stIRBValueChanged = (e) => {
    dispatch(
      updateIRBRptDate({
        "1st": e.value ? e.value : null,
      })
    );
  };

  const on2ndRBValueChanged = (e) => {
    dispatch(
      updateIRBRptDate({
        "2nd": e.value ? e.value : null,
      })
    );
  };

  const on3rdRBValueChanged = (e) => {
    dispatch(
      updateIRBRptDate({
        "3rd": e.value ? e.value : null,
      })
    );
  };

  const on4thRBValueChanged = (e) => {
    dispatch(
      updateIRBRptDate({
        "4th": e.value ? e.value : null,
      })
    );
  };

  const on5thRBValueChanged = (e) => {
    dispatch(
      updateIRBRptDate({
        "5th": e.value ? e.value : null,
      })
    );
  };

  const onIRBRptCmtValueChanged = (e) => {
    dispatch(
      updateIRBRptCmt({
        IRBRptCmt: e.value ? e.value : null,
      })
    );
  };

  return (
    <Form
      id="form-SAE"
      ref={formSAERef}
      colCount={4}
      labelMode="outside"
      labelLocation="top"
      showColonAfterLabel={true}
      style={{
        padding: "16px",
      }}
      validationGroup="SAEData"
    >
      <SimpleItem
        // dataField={"siteNo"}
        editorType={"dxSelectBox"}
        editorOptions={{
          dataSource: siteDataSource,
          valueExpr: "siteNo",
          showClearButton: true,
          value: SAE.siteNo,
          readOnly: SAE.action == "insert" ? false : true,
          itemRender: itemRender,
          displayExpr: displayExpr,
          onValueChanged: onSiteNoValueChanged,
        }}
        colSpan={2}
      >
        <Label text={"Site Info."} />
        <RequiredRule message={"Site Info. is required."} />
      </SimpleItem>
      <SimpleItem
        // dataField={"subjectNo"}
        editorType={"dxTextBox"}
        editorOptions={{
          value: SAE.subjectNo,
          showClearButton: true,
          onValueChanged: onSubjectNoValueChanged,
        }}
      >
        <Label text={"Subject No."} />
        <RequiredRule message={"Subject No. is required."} />
      </SimpleItem>
      <EmptyItem />
      <GroupItem caption="SAE Log" colSpan={4} colCount={4}>
        <SimpleItem
          // dataField={"rptTerm"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: SAE.rptTerm,
            showClearButton: true,
            onValueChanged: onRptTermValueChanged,
          }}
        >
          <Label text={"Reported Term"} />
          <RequiredRule message={"Reported term is required."} />
        </SimpleItem>
        <SimpleItem
          // dataField={"onsetDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: SAE.onsetDate,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            useMaskBehavior: true,
            onValueChanged: onOnsetDateValueChanged,
          }}
        >
          <Label text={"Onset Date"} />
          <RequiredRule message={"Onset date is required."} />
        </SimpleItem>
        <SimpleItem
          // dataField={"ongoing"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: NY,
            value: SAE.ongoing,
            valueExpr: "id",
            displayExpr: "name",
            showClearButton: true,
            onValueChanged: onOngoingValueChanged,
          }}
        >
          <Label text={"Ongoing"} />
          <RequiredRule message={"Ongoing is required."} />
        </SimpleItem>
        <SimpleItem
          // dataField={"endDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: SAE.endDate,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            readOnly: SAE.ongoing != "N" ? true : false,
            useMaskBehavior: true,
            onValueChanged: onEndDateValueChanged,
          }}
        >
          <Label text={"End date"} />
        </SimpleItem>
      </GroupItem>
      <GroupItem caption={"Report"} colCount={4} colSpan={4}>
        <SimpleItem
          // dataField={"initial"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: SAE.fuRptDate["initial"],
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            useMaskBehavior: true,
            onValueChanged: onInitialValueChanged,
          }}
        >
          <Label text={"Initial Report (SAE Case)"} />
        </SimpleItem>
        <GroupItem caption={"Follow-up Report"} colCount={5} colSpan={3}>
          <SimpleItem
            // dataField={"1st"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.fuRptDate["1st"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.fuRptDate["initial"] ? false : true,
              useMaskBehavior: true,
              onValueChanged: on1stValueChanged,
            }}
          >
            <Label text={"1st"} />
          </SimpleItem>
          <SimpleItem
            // dataField={"2nd"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.fuRptDate["2nd"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.fuRptDate["initial"] ? false : true,
              useMaskBehavior: true,
              onValueChanged: on2ndValueChanged,
            }}
          >
            <Label text={"2nd"} />
          </SimpleItem>
          <SimpleItem
            // dataField={"3rd"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.fuRptDate["3rd"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.fuRptDate["initial"] ? false : true,
              useMaskBehavior: true,
              onValueChanged: on3rdValueChanged,
            }}
          >
            <Label text={"3rd"} />
          </SimpleItem>
          <SimpleItem
            // dataField={"4th"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.fuRptDate["4th"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.fuRptDate["initial"] ? false : true,
              useMaskBehavior: true,
              onValueChanged: on4thValueChanged,
            }}
          >
            <Label text={"4th"} />
          </SimpleItem>
          <SimpleItem
            // dataField={"5th"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.fuRptDate["5th"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.fuRptDate["initial"] ? false : true,
              useMaskBehavior: true,
              onValueChanged: on5thValueChanged,
            }}
          >
            <Label text={"5th"} />
          </SimpleItem>
          <SimpleItem
            // dataField={"6th"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.fuRptDate["6th"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.fuRptDate["initial"] ? false : true,
              useMaskBehavior: true,
              onValueChanged: on6thValueChanged,
            }}
          >
            <Label text={"6th"} />
          </SimpleItem>
          <SimpleItem
            // dataField={"7th"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.fuRptDate["7th"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.fuRptDate["initial"] ? false : true,
              useMaskBehavior: true,
              onValueChanged: on7thValueChanged,
            }}
          >
            <Label text={"7th"} />
          </SimpleItem>
          <SimpleItem
            // dataField={"8th"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.fuRptDate["8th"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.fuRptDate["initial"] ? false : true,
              useMaskBehavior: true,
              onValueChanged: on8thValueChanged,
            }}
          >
            <Label text={"8th"} />
          </SimpleItem>
          <SimpleItem
            // dataField={"9th"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.fuRptDate["9th"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.fuRptDate["initial"] ? false : true,
              useMaskBehavior: true,
              onValueChanged: on9thValueChanged,
            }}
          >
            <Label text={"9th"} />
          </SimpleItem>
          <SimpleItem
            // dataField={"10th"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.fuRptDate["10th"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.fuRptDate["initial"] ? false : true,
              useMaskBehavior: true,
              onValueChanged: on10thValueChanged,
            }}
          >
            <Label text={"10th"} />
          </SimpleItem>
        </GroupItem>
        <SimpleItem
          // dataField={"cmt"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: SAE.cmt,
            showClearButton: true,
            onValueChanged: onCmtValueChanged,
          }}
          colSpan={4}
        >
          <Label text={"Comment"} />
        </SimpleItem>
        <SimpleItem
          // dataField={"IRBRpt"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: NY,
            value: SAE.IRBRpt,
            valueExpr: "id",
            displayExpr: "name",
            showClearButton: true,
            onValueChanged: onIRBRptValueChanged,
          }}
        >
          <Label text={"Becco's IRB Reporting"} />
        </SimpleItem>
        <GroupItem caption={"IRB Reporting"} colCount={5} colSpan={3}>
          <SimpleItem
            // dataField={"1st"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.IRBRptDate["1st"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.IRBRpt == "Y" ? false : true,
              useMaskBehavior: true,
              onValueChanged: on1stIRBValueChanged,
            }}
          >
            <Label text={"1st"} />
          </SimpleItem>
          <SimpleItem
            // dataField={"2nd"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.IRBRptDate["2nd"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.IRBRpt == "Y" ? false : true,
              useMaskBehavior: true,
              onValueChanged: on2ndRBValueChanged,
            }}
          >
            <Label text={"2nd"} />
          </SimpleItem>
          <SimpleItem
            // dataField={"3rd"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.IRBRptDate["3rd"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.IRBRpt == "Y" ? false : true,
              useMaskBehavior: true,
              onValueChanged: on3rdRBValueChanged,
            }}
          >
            <Label text={"3rd"} />
          </SimpleItem>
          <SimpleItem
            // dataField={"4th"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.IRBRptDate["4th"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.IRBRpt == "Y" ? false : true,
              useMaskBehavior: true,
              onValueChanged: on4thRBValueChanged,
            }}
          >
            <Label text={"4th"} />
          </SimpleItem>
          <SimpleItem
            // dataField={"5th"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: SAE.IRBRptDate["5th"],
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: SAE.IRBRpt == "Y" ? false : true,
              useMaskBehavior: true,
              onValueChanged: on5thRBValueChanged,
            }}
          >
            <Label text={"5th"} />
          </SimpleItem>
        </GroupItem>
        <SimpleItem
          // dataField={"IRBRptCmt"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: SAE.IRBRptCmt,
            showClearButton: true,
            onValueChanged: onIRBRptCmtValueChanged,
          }}
          colSpan={4}
        >
          <Label text={"Comment"} />
        </SimpleItem>
      </GroupItem>
    </Form>
  );
}
